import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardText
} from 'reactstrap';
import { doGetCompletedProcessedList, doDisburseSellerSale, doUpdateAwbNumberSale, manualDisburse } from '../../../actions/saleAction';
import { DEFAULT_SORT_BY, DEFAULT_PER_PAGE } from '../../../constants/settings';
import { DEFAULT_CATEGORY_NAME } from '../../../constants/kickavenue';
import privateView from '../../../components/hocs/privateView';
import { CardHeaderWithToolbars,Title } from '../../../components/Card/CardHeaderWithToolbars';
import { ModalConfirmation } from '../../../components/Modals';
import FilterContainer from '../../../components/Container/FilterContainer/FilterContainer';
import ExportModal from '../../../components/Export/ExportModal';
import SalesExportFilters, { SALES_EXPORT_DEFAULTS, toSalesParams, normalizeSalesFilters } from '../Modals/SalesExportFilters';
import { SALES_EXPORT_COLUMNS, SALES_EXPORT_ROUTE, SALES_ADMIN_ROLES, saleRow, pickColumns } from '../salesExport';
import { rowsToCsv, downloadCsv, fetchAllPages, ExportLimitError, EXPORT_MAX_ROWS } from '../../../utils/exportCsv';
import { goClient, countRows, requestEmailExport, exportStatus, isRequestError } from '../../../utils/exportClient';
import { loadSellers } from '../../../utils/exportOptions';

import ProcessedList from './ProcessedList';
import FiltersPanel from '../Filters';
import Toolbars from './processedList/filterPanel/Toolbars';
import Analytics from "../../../services/Analytics";

const defaultParams = {
  type:'processed',
  sort_by : DEFAULT_SORT_BY,
  per_page : DEFAULT_PER_PAGE,
  category: DEFAULT_CATEGORY_NAME
}

class Processed extends Component{
  constructor(props){
    super(props);
    this.state = {
      _pagination:{
        perPage: 0,
        from: 0,
        to: 0,
        total: 0,
        lastPage: 0,
        nextPageUrl: null,
        path: null,
        prevPageUrl: null
      },
      _params: { ...defaultParams },
      _filterOpen: false,
      _exportOpen: false,
      _exportModalOpen: false,
      _isExporting: false,
      _exportProgress: 0,
      _exportRowCount: 0,
      _emailStatus: null,
      _isResetFilter: false
    }
    this._handleGoto = this._handleGoto.bind(this);
    this._handleToggleFilterPanel = this._handleToggleFilterPanel.bind(this);
    this._handleToggleExportPanel = this._handleToggleExportPanel.bind(this);
    this._handleRefresh = this._handleRefresh.bind(this);
    this._handleResetFilter = this._handleResetFilter.bind(this);
    this._toggleExportModal = this._toggleExportModal.bind(this);
    this._countExportRows = this._countExportRows.bind(this);
    this._handleExportCsv = this._handleExportCsv.bind(this);
    this._handleExportEmail = this._handleExportEmail.bind(this);    this._handleApplyFilter = this._handleApplyFilter.bind(this);
    this._handleDisburseJob = this._handleDisburseJob.bind(this);
  }

  componentWillUnmount(){
    this._unmounted = true;
  }

  componentDidMount(){
    const { email } = this.props.injectedProps;
    this._refreshList();
    Analytics.recordPageView('processed_sales', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  _handleGoto(page){
    const _params=this.state._params;
    _params.page=page;
    this.setState({_params}, ()=>this._getList(this.state._params));
  }

  _getList(rawParams = {}){
    let p = { ...rawParams }
    if(p.voucher){
      const { voucher, ...other } = p;
      if(Number(voucher.id)){
        p = { ...other, voucher_id: voucher.id }
      }
      else{
        p = { ...other, voucher_code: voucher.code }
      }
    }
    if(p.seller && p.seller.id){
      const { seller, ...other } = p;
      p = { ...other, seller_id: seller.id }
    }
    const params = Object.keys(p)
    .filter(key => p[key]!='')
    .reduce((obj, current)=> ({...obj, [current]: p[current]}), {});
    this.props.getList({params});
  }

  _refreshList(){
    // Exclude page...
    const { page, ..._params } = this.state._params;
    this.setState({
      _params:{ ..._params }
    },()=>this._getList(this.state._params));
  }

  componentDidUpdate(lastProps){
    if(lastProps.sale.isFetch && lastProps.sale.isFetch !== this.props.sale.isFetch){
      const { error } = this.props.sale;
      if(!error){
        const { list } = this.props.sale;
        this.setState({
          // _list: data,
          _pagination:{
            perPage: list.per_page,
            from: list.from,
            to: list.to,
            total: list.total,
            lastPage: list.last_page,
            currentPage: list.current_page,
            nextPageUrl: list.next_page_url,
            path: list.path,
            prevPageUrl: list.prev_page_url,
            statusCode: list.status_code
          }
        })
      }
    }
  }

  _handleToggleFilterPanel(e){
    e.preventDefault();
    this._toggleFilterPanel();
  }

  _handleToggleExportPanel(e){
    e.preventDefault();
    this._toggleExportPanel();
  }

  _toggleFilterPanel(){
    const exportState = this.state._exportOpen?{_exportOpen:!this.state._exportOpen}:{};
    this.setState({
      ...exportState,
      _filterOpen:!this.state._filterOpen
    })
  }

  _toggleExportPanel(){
    const filterState = this.state._filterOpen?{_filterOpen:!this.state._filterOpen}:{};
    this.setState({
      ...filterState,
      _exportOpen:!this.state._exportOpen});
  }

  _handleRefresh(e){
    e.preventDefault();
    this._refreshList();
  }


  _setStateIfMounted(patch){
    if (!this._unmounted) this.setState(patch);
  }

  _isAdmin(){
    const roles = (this.props.injectedProps && this.props.injectedProps.roles) || [];
    const list = Array.isArray(roles) ? roles : String(roles).split(',');
    return list.some(r => SALES_ADMIN_ROLES.includes(String(r).trim()));
  }

  _toggleExportModal(){
    if(this.state._isExporting) return;
    this.setState({ _exportModalOpen: !this.state._exportModalOpen });
  }

  _exportParams(filters){
    const { page, per_page, ..._rest } = normalizeSalesFilters(this.state._params);
    const panel = {};
    Object.keys(_rest)
      .filter(key => _rest[key] !== '' && _rest[key] != null)
      .forEach(key => { panel[key] = _rest[key]; });
    return toSalesParams(panel, filters);
  }

  _countExportRows(filters){
    return countRows(goClient(), SALES_EXPORT_ROUTE, this._exportParams(filters));
  }

  async _handleExportCsv(filters, columns){
    if(this.state._isExporting) return;
    this._setStateIfMounted({ _isExporting: true, _exportProgress: 0, _exportRowCount: 0, _emailStatus: null });
    try {
      const rows = await fetchAllPages(goClient(), SALES_EXPORT_ROUTE, { ...this._exportParams(filters), without_append: 1 }, {
        onProgress: (progress, count) => this._setStateIfMounted({ _exportProgress: progress, _exportRowCount: count })
      });
      if (this._unmounted) return;
      if (!rows.length) {
        this._setStateIfMounted({ _isExporting: false, _exportProgress: 0, _exportRowCount: 0 });
        window.alert('No sales match the selected options.');
        return;
      }
      const stamp = new Date().toISOString().slice(0, 10);
      downloadCsv(rowsToCsv(rows.map(item => pickColumns(saleRow(item), columns))), `sales_${stamp}.csv`);
      this._setStateIfMounted({ _isExporting: false, _exportProgress: 100, _exportModalOpen: false });
    } catch (err) {
      this._setStateIfMounted({ _isExporting: false, _exportProgress: 0, _exportRowCount: 0 });
      if (this._unmounted) return;
      if (err instanceof ExportLimitError) { window.alert(err.message); return; }
      if (isRequestError(err)) { window.alert('Export failed. Please try again.'); return; }
      throw err;
    }
  }

  async _handleExportEmail(filters, columns){
    if(this.state._isExporting) return;
    this._setStateIfMounted({ _isExporting: true, _emailStatus: null });
    try {
      const client = goClient();
      const filtersForServer = {};
      Object.entries(this._exportParams(filters)).forEach(([k, v]) => { filtersForServer[k] = String(v); });
      let status = await requestEmailExport(client, 'sales', filtersForServer, columns);
      this._setStateIfMounted({ _emailStatus: status });
      while (status && (status.state === 'queued' || status.state === 'waiting' || status.state === 'running')) {
        await new Promise(resolve => setTimeout(resolve, 5000));
        if (this._unmounted) return;
        status = await exportStatus(client, status.id);
        this._setStateIfMounted({ _emailStatus: status });
      }
      this._setStateIfMounted({ _isExporting: false });
    } catch (err) {
      const data = err && err.response && err.response.data;
      const message = data && data.errors && data.errors.columns ? data.errors.columns.join(' ') : (data && data.message) || 'Email export failed. Please try again.';
      this._setStateIfMounted({ _isExporting: false, _emailStatus: { state: 'failed', message } });
    }
  }

  _handleDisburseJob(e) {
    e.preventDefault()
    this.confirmationToggle();
  }

  _handleResetFilter(e){
    e.preventDefault();
    const exportState = this.state._exportOpen?{_exportOpen:!this.state._exportOpen}:{};
    this.setState({
      ...exportState,
      _params:{
        ...defaultParams
      },
      _isResetFilter: true
    },()=>this._getList(this.state._params));
  }

  _handleApplyFilter(payloadFilter){
    this.setState({
      _params: {
        ...this.state._params,
        ...payloadFilter,
        type: 'processed',
        page: 1
      }
    },()=>this._getList(this.state._params));
  }

  confirmationToggle = () => {
    this.setState({ isConfirmationOpen: !this.state.isConfirmationOpen })
  }

  render(){
    return (
      <div className="animated fadeIn">
        <ModalConfirmation
          isOpen={this.state.isConfirmationOpen}
          onSubmit={() => {
            this.props.manualDisburse()
            this._refreshList();
            this.confirmationToggle();
          }}
          toggle={this.confirmationToggle}
        />
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeaderWithToolbars>
                <Title>
                  <i className="fa fa-align-justify"></i>
                  <span>Processed List</span>
                </Title>
                <Toolbars
                  isOpen={this.state._filterOpen}
                  exporting={this.state._isExporting}
                  onToggleFilter={this._handleToggleFilterPanel}
                  onToggleExport={this._toggleExportModal}
                  onRefreshList={this._handleRefresh}
                  onResetFilter={this._handleResetFilter}
                  onDisburse={this._handleDisburseJob}
                />
              </CardHeaderWithToolbars>
              <FilterContainer>
                <FiltersPanel
                  {...this.state._params}
                  isOpen={this.state._filterOpen}
                  onApplyFilter={this._handleApplyFilter}
                  isReset={this.state._isResetFilter}
                  onResetFilterCallback={()=>this.setState({_isResetFilter: false, _filterOpen: false})}
                />
              </FilterContainer>
              <ExportModal
                  isOpen={this.state._exportModalOpen}
                  toggle={this._toggleExportModal}
                  title="Export Processed Sales"
                  screen="sales"
                  columns={SALES_EXPORT_COLUMNS}
                  isAdmin={this._isAdmin()}
                  defaultFilters={{ ...SALES_EXPORT_DEFAULTS, status: [{ id: 'processed', name: 'Processed' }], date_field: 'ka_sent' }}
                  renderFilters={(filters, setFilter, disabled) => (
                    <SalesExportFilters filters={filters} setFilter={setFilter} disabled={disabled}
                      categoryOptions={this.props.categoryOptions} loadSellers={loadSellers} />
                  )}
                  countRows={this._countExportRows}
                  onDownload={this._handleExportCsv}
                  onEmail={this._handleExportEmail}
                  isExporting={this.state._isExporting}
                  progress={this.state._exportProgress}
                  rowCount={this.state._exportRowCount}
                  maxRows={EXPORT_MAX_ROWS}
                  emailStatus={this.state._emailStatus}
                  userEmail={this.props.injectedProps && this.props.injectedProps.email}
                />
              <CardBody>
                <CardText>
                  All orders after delivering process. Increase seller's points and balance, when you click Processed button.
                </CardText>
                <ProcessedList
                  {...this.state._pagination}
                  loginId={this.props.injectedProps.id}
                  dataUpdatedSale={this.props.updatedSale}
                  list={this.props.sale.list.data}
                  isLoading={this.props.sale.isFetch}
                  handleGotoList={this._handleGoto}
                  handleCompletionSale={(id, payload) => this.props.completingSale(id, payload)}
                  handleUpdateAwbNumber={(id, payload)=> this.props.updateAwbNumber(id, payload)}
                  email={this.props.email}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps= ({ sale:{ processed, report_sale, ...other }, auth:{id: authId, isFetch, isLogged, roles, email}, masterCategories}) => {
	return {
    sale: processed.completed,
    saleReport: report_sale,
    updatedSale: other,
    email,
    guardData: {isFetch, isLogged, roles, id: authId, email},
    categoryOptions: masterCategories.options
	}
};

const mapDispatchToProps = (dispatch) => ({
  getList:(query) => dispatch(doGetCompletedProcessedList(query)),
  completingSale:(id,payload) => dispatch( doDisburseSellerSale(id,payload)),
  updateAwbNumber:(id,payload) => dispatch( doUpdateAwbNumberSale(id,payload)),
  manualDisburse: () => dispatch( manualDisburse() ),
})
const enhance = connect(mapStateToProps, mapDispatchToProps);

export default enhance(privateView(Processed, ['supervisor','sale_supervisor']));